import { Injectable } from "@angular/core";
import { AbstractClass, TableCell } from "@classes/abstract.class";
import { DocumentType } from '@models/document-type';

@Injectable({providedIn: 'root'})
export class DocumentTypeClass extends AbstractClass {
  model: DocumentType;
  modelName = 'DocumentType';
  idName = 'documentTypeID';
  langBase = 'cms.components.document-type.';
  route = 'cms/user/document-type';
  tableCells: TableCell[] = [
    { name: 'type', label: 'type', cellType: 'text', order: true, download: true },
    { name: 'isActive', label: 'status', cellType: 'active-text', order: true, download: true },
    { name: 'createdAt', label: 'createdAt', cellType: 'date', order: true, download: true },
    //{ name: 'siteLocation.city.countryZone.zoneName', label: 'countryZone', cellType: 'text', order: true },
    //{ name: 'siteLocation.city.cityName', label: 'city', cellType: 'text', order: true },
  ];
  formAccordion = [];
  formTabs = [];
  formCells = [
    // { name: 'name', label: 'name', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false },
    { name: 'type', label: 'type', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'string' },
    { name: 'isActive', label: 'isActive', cellType: 'checkbox', disable: false, order: 6, cols: 'col-12 col-md-6', required: false, multiple: false, type: 'boolean' }
  ];
  modelCells = [];
  tabs = [];

  constructor()
  {
    super();
    this.model = {
      documentTypeID: 0,
      type: '',
      isActive: true,
      createdBy: '',
      createdAt: new Date(),
      updatedAt: new Date()
    };
  }
}
